import AnimateLine from "../../common/AnimateLine";
import SubscribArea from "../../common/SubscribArea";
import AboutArea from "./AboutArea";
import NewHeroArea from "./NewHeroArea";
import TractionBar from "./TractionBar";
import ProductPortfolio from "./ProductPortfolio";
import AchievementsAwards from "./AchievementsAwards";
import "../../../assets/css/sections.css";

function HomePageOne() {
  return (
    <div className="dlplatforms-wrap">
      <AnimateLine />

      {/* 1. Who we are */}
      <NewHeroArea />

      {/* 2. Proof, up front: combined reach and per-product traction */}
      <TractionBar />

      {/* 3. What we've built */}
      <ProductPortfolio />

      {/* 4. How we operate, plus awards and team imagery */}
      <AboutArea />

      {/* 5. Third-party validation */}
      <AchievementsAwards />

      <SubscribArea />

      {/*
        Removed from the landing page during the portfolio repositioning.
        Components are still on disk if the creator-services story is ever
        needed again (e.g. a dedicated /services page):
          <PlatformShowcase />    social-platform logo scroller
          <VideoWorkShowcase />   "content we create for our clients"
          <SocialProofVideos />   video testimonials from creators
          <ServiceArea />         agency service cards
          <Testimonial />         written client testimonials
      */}
    </div>
  );
}

export default HomePageOne;
